import { observer } from 'mobx-react';

const MapViewButtons = observer(
  ({
    activeMapView,
    map,
    mapDefaultZoomLevel,
    satelliteView,
    setActiveMapView,
    terrainView,
  }) => {
    const toggleMapView = (viewId, themeType) => {
      setActiveMapView(viewId);

      if (viewId == 'satellite') {
        map.setMaxZoom(11);
      } else {
        map.setMaxZoom(mapDefaultZoomLevel);
      }

      map.setStyle(`mapbox://styles/charitywater/${themeType}`);
    };

    const setMapViewButtonClass = (view) =>
      `no-underline cursor-pointer flex items-center justify-center ${view} ${
        view == activeMapView ? 'hidden' : 'active'
      }`;

    return (
      <div className='map-button-switcher toggle-buttons'>
        <a
          className={setMapViewButtonClass('terrain')}
          onClick={() => toggleMapView('terrain', terrainView)}
        >
          <span className='inline-block' />
        </a>

        <a
          className={setMapViewButtonClass('satellite')}
          onClick={() => toggleMapView('satellite', satelliteView)}
        >
          <span className='inline-block' />
        </a>
      </div>
    );
  }
);

export default MapViewButtons;
